import { Grid } from '@mui/material';
import State from '../../../Models/Locations/state';
import Panel from '../../../components/UI/Panel';
import TimeZone from '../../../Models/Locations/TimeZone';
import GenericInput from './UI/GenericInput';
import GenericSelectInput from './UI/GenericSelectInput';
import CustodianFieldSearchInput from './CustodianFieldSearchInput';
import CheckboxInput from './UI/CheckboxInput';
import { useState } from 'react';

type Props = {
    states: State[];
    timeZones: TimeZone[];
    formik: any;
    copyMainAddress?: (formKeyName: string) => void;
    showPanel: boolean;
    isEdit?: boolean;
};

const MailingAddress = ({
    states,
    timeZones,
    formik,
    showPanel,
    copyMainAddress,
    isEdit = false
}: Props) => {

    const [asMainAddress, setAsMainAddress] = useState<boolean>()

    const clearCopiedAddress = () => {
        formik.setFieldValue(
            'mailingAddress.addressDetails', '',
        );

        formik.setFieldValue(
            'mailingAddress.city', '',
        );

        formik.setFieldValue(
            'mailingAddress.postCode', '',
        );

        formik.setFieldValue(
            'mailingAddress.stateId', '',
        );

        formik.setFieldValue(
            'mailingAddress.timeZoneId', '',
        );
    }

    const CopyMainAddress = () => {
        return (
            <CheckboxInput
                label="Copy Main Address"
                checked={asMainAddress}
                keyName=""
                onChange={(e: any) => {
                    setAsMainAddress(e.target.checked);
                    if (e.target.checked && copyMainAddress) {
                        copyMainAddress('mailingAddress');
                    }
                    else {
                        clearCopiedAddress()
                    }
                }}
                onBlur={() => { }}
            />
        );
    };    

    const content = (
        <>
            {<CopyMainAddress />}
            <Grid spacing={2} mx={1} container>
                <Grid item xs={4} px={2}>
                    <CustodianFieldSearchInput
                        duplicateErrorMessage="The address you have entered is slightly similar to the addresses of existing custodians. This could indicate that the custodian you are trying to create may already exist."
                        label="Address"
                        isExactSearch={false}
                        name="mailingAddress.addressDetails"
                        placeholder="Address"
                        maxLength={120}
                        value={formik?.values?.mailingAddress?.addressDetails}
                        formErrorMessage={
                            formik?.touched?.mailingAddress?.addressDetails &&
                                formik?.errors?.mailingAddress?.addressDetails
                                ? formik?.errors?.mailingAddress?.addressDetails
                                : ''
                        }
                        hasFormError={
                            !!(formik?.touched?.mailingAddress?.addressDetails &&
                                formik?.errors?.mailingAddress?.addressDetails)
                        }
                        onChange={(e: any) => {
                            formik?.setFieldValue(`mailingAddress.addressDetails`, e.target.value);
                        }}
                        onBlur={() => {
                            formik?.setFieldTouched(`mailingAddress.addressDetails`, true);
                        }}
                        searchPropertyName="address"
                        required={true}
                    />
                </Grid>
                <Grid item xs={4} px={2}>
                    <GenericInput
                        name="city"
                        label="City"
                        placeholder="City"
                        maxLength={40}
                        value={formik?.values?.mailingAddress?.city}
                        onChange={(e: any) => {
                            formik?.setFieldValue(`mailingAddress.city`, e.target.value);
                        }}
                        errorMsg={
                            formik?.touched?.mailingAddress?.city &&
                                formik?.errors?.mailingAddress?.city
                                ? formik?.errors?.mailingAddress?.city
                                : ''
                        }
                        hasError={
                            !!(formik?.touched?.mailingAddress?.city &&
                                formik?.errors?.mailingAddress?.city)
                        }
                        onBlur={() => {
                            formik?.setFieldTouched(`mailingAddress.city`, true);
                        }}
                        required={true}
                    />
                </Grid>
                <Grid item xs={4} px={2}>
                    <GenericSelectInput
                        name={`stateId`}
                        label="State"
                        value={formik?.values?.mailingAddress?.stateId}
                        onChange={(e: any) => {
                            formik?.setFieldValue(`mailingAddress.stateId`, e);
                        }}
                        errorMsg={
                            formik?.touched?.mailingAddress?.stateId &&
                                formik?.errors?.mailingAddress?.stateId
                                ? formik?.errors?.mailingAddress?.stateId
                                : ''
                        }
                        hasError={
                            !!(formik?.touched?.mailingAddress?.stateId &&
                                formik?.errors?.mailingAddress?.stateId)
                        }
                        onBlur={() => {
                            formik?.setFieldTouched(`mailingAddress.stateId`, true);
                        }}
                        options={states}
                        required={true}
                    />
                </Grid>
                <Grid item xs={4} px={2}>
                    <GenericInput
                        name="postCode"
                        label="Zip / Postal Code"
                        placeholder="Zip / Postal Code"
                        maxLength={5}
                        value={formik?.values?.mailingAddress?.postCode}
                        onChange={(e: any) => {
                            formik?.setFieldValue(`mailingAddress.postCode`, e.target.value);
                        }}
                        errorMsg={
                            formik?.touched?.mailingAddress?.postCode &&
                                formik?.errors?.mailingAddress?.postCode
                                ? formik?.errors?.mailingAddress?.postCode
                                : ''
                        }
                        hasError={
                            !!(formik?.touched?.mailingAddress?.postCode &&
                                formik?.errors?.mailingAddress?.postCode)
                        }
                        onBlur={() => {
                            formik?.setFieldTouched(`mailingAddress.postCode`, true);
                        }}
                        required={true}
                    />
                </Grid>
                <Grid item xs={4} px={2}>
                    <GenericSelectInput
                        name={`timeZoneId`}
                        label="TimeZone"
                        value={formik?.values?.mailingAddress?.timeZoneId}
                        onChange={(e: any) => {
                            formik?.setFieldValue(`mailingAddress.timeZoneId`, e);
                        }}
                        errorMsg={
                            formik?.touched?.mailingAddress?.timeZoneId &&
                                formik?.errors?.mailingAddress?.timeZoneId
                                ? formik?.errors?.mailingAddress?.timeZoneId
                                : ''
                        }
                        hasError={
                            !!(formik?.touched?.mailingAddress?.timeZoneId &&
                                formik?.errors?.mailingAddress?.mailingAddress &&
                                formik?.errors?.mailingAddress?.timeZoneId)
                        }
                        onBlur={() => {
                            formik?.setFieldTouched(`mailingAddress.timeZoneId`, true);
                        }}
                        options={timeZones}
                    />
                </Grid>
            </Grid>
        </>
    );

    return (
        <>
            {showPanel ? (
                <Panel headerText="Mailing Details">{content}</Panel>
            ) : (
                content
            )}
        </>
    );
};

MailingAddress.defaultProps = {
    showPanel: true,
};

export default MailingAddress;